<template>
  <VTimeline dense align-top v-bind="$attrs">
    <VTimelineItem
      v-for="(item, i) in items"
      :key="'timeline-item-' + i"
      small
      fill-dot
      class="pr-2"
      :icon="item.icon"
      :color="item.color"
    >
      <div
        class="float-right text-caption grey--text pl-2"
        :title="formatDateVerbose(item.date)"
        style="margin-top: 1px"
        v-text="formatDateDistanceToNowIfRecentShort(item.date)"
      />
      <h5 class="text-subtitle-2" v-text="item.title" />
      <div
        v-if="item.caption"
        class="text-truncate"
        v-text="replaceEscapedNewlines(item.caption)"
      />
    </VTimelineItem>
  </VTimeline>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import {
  formatDateDistanceToNowIfRecentShort,
  formatDateVerbose
} from '@/components/mixins/dateFormatters'

export interface TimelineItem {
  date: Date
  title: string
  caption?: string
  color?: string
  icon?: string
}

export default defineComponent({
  props: {
    items: {
      type: Array as PropType<TimelineItem[]>,
      required: true
    }
  },
  setup() {
    const escapedNewline = /\\n/g
    return {
      formatDateDistanceToNowIfRecentShort,
      formatDateVerbose,
      // TODO: Move logic to Vuex store as part of ingestion and schema normalization to centralize the fix
      /**
       * Literal \n appears in some ticket captions. This replaces \n with actual newlines.
       */
      replaceEscapedNewlines: (s: string) =>
        s && s.replace(escapedNewline, '\n')
    }
  }
})
</script>
